import React, { useEffect } from 'react';
import { Collapse, Typography } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Snackbar from '@material-ui/core/Snackbar';

export default function PushMessage({ message, severityScore, open, setOpen }) {
  if (message === undefined) {
    return <></>;
  }

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  return (
    <div>
      <Snackbar
        open={open}
        autoHideDuration={10000}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          style={{ /*height: 55,*/ width: 500 }}
          variant="filled"
          onClose={handleClose}
          action={
            <>
              <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleClose}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </>
          }
          severity={severityScore}
        >
          <Typography style={{ fontSize: 12 }}>{message}</Typography>
        </Alert>
      </Snackbar>
    </div>
  );
}
